"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateSectionPositionsMutationOptions = exports.updateSectionPositionsMutation = void 0;
const client_1 = require("@apollo/client");
exports.updateSectionPositionsMutation = client_1.gql `
  mutation UpdateSectionPositions($ids: [String!]!) {
    updateSectionPositions(ids: $ids) {
      __typename
      ok
      sections {
        __typename
        id
        position
      }
    }
  }
`;
exports.updateSectionPositionsMutationOptions = (variables) => ({
    variables,
    optimisticResponse: {
        __typename: "Mutation",
        updateSectionPositions: {
            __typename: "SectionsResponse",
            ok: true,
            sections: variables.ids.map((x, i) => ({
                __typename: "Section",
                id: x,
                position: i,
            })),
        },
    },
});
//# sourceMappingURL=updateSectionPositions.js.map